<template>
  <div class="h-full">
    <el-input
      size="small"
      :placeholder="placeholder"
      :value="userName"
      clearable
      :disabled="disabled"
      @clear="clearName"
      v-if="isShowUerInput"
    >
      <template slot="append">
        <el-button type="primary" size="small" :disabled="disabled" @click="initDialog"
          >选择</el-button
        >
      </template>
    </el-input>
    <slot v-else></slot>
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      title="选择人员"
      :visible.sync="organDialog"
      top="2vh"
      class="mid-dialog"
      v-dialogDrag
    >
      <div class="w-full h-full">
        <div class="mb-20px flex justify-between items-center">
          <div class="flex">
            <el-input
              size="small"
              placeholder="请输入人员姓名"
              v-model="searchPeople"
              class="mr-10px flex-1"
              clearable
              @clear="clearSearchName"
            ></el-input>
            <el-tooltip placement="top" content="搜索" :enterable="false">
              <el-button type="primary" size="small" @click="searchPeopleFunc">搜索</el-button>
            </el-tooltip>
          </div>
        </div>
        <!-- @selection-change="peopleSelectionChange" -->
        <!-- 目前只支持单选，后面有需求在增加 -->
        <el-table
          :data="tableData"
          border
          stripe
          height="calc(100% - 120px)"
          v-loading="tableLoading"
          :highlight-current="true"
          :default-sort="{ prop: 'date', order: 'decending' }"
          @cell-click="handleSelect"
        >
          <el-table-column
            type="index"
            label="序号"
            show-overflow-tooltip
            width="60"
          ></el-table-column>
          <el-table-column
            label="姓名"
            show-overflow-tooltip
            sortable
            prop="name"
          ></el-table-column>
          <el-table-column
            label="账户"
            show-overflow-tooltip
            sortable
            prop="userName"
          ></el-table-column>
          <el-table-column
            label="所属部门"
            width="230px"
            show-overflow-tooltip
            sortable
            prop="orgUnits"
          >
            <template slot-scope="scope">
              <el-tag
                class="mx-5px"
                size="mini"
                v-for="item in scope.row.orgUnits"
                :key="item.id"
                >{{ item.organizationUnitName }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="职务" show-overflow-tooltip sortable prop="lables">
            <template slot-scope="scope">
              <el-tag class="mx-5px" size="mini" v-for="item in scope.row.posts" :key="item.id">{{
                item.postName
              }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex justify-end mt-20px">
          <el-pagination
            background
            @size-change="tableSizeChange"
            @current-change="tableCurrentChange"
            :current-page.sync="pageConfig.SkipCount"
            layout="total, sizes, prev, pager, next, jumper"
            :page-size.sync="pageConfig.MaxResultCount"
            :total="total"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
            :pager-count="5"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
import { EafOrganizationUnitUserApi } from '@wiz-api/account'

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  name: 'person-select',
  components: {},
  props: {
    placeholder: {
      default: '请选择人员',
    },
    // 是否显示内置选择输入框
    isShowUerInput: {
      type: Boolean,
      default: true,
    },
    // 是否禁用选择按钮
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: '',
    },
    // 是否渲染选中样式
    isRenderSelect: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      userName: '',
      userId: '',
      searchPeople: null,
      defaultData: null,
      parentIdList: [],
      tableLoading: false,
      treeKeyword: '',
      showChangeDepartDialog: false,
      showDepartDialog: false,
      peopleProps: {
        visible: false,
        title: '人员详情',
        data: '',
        type: 'edit',
      },
      pageConfig: {
        MaxResultCount: 15,
        SkipCount: 1,
      },
      showAddPersonDialog: false,
      tableData: [],
      choiceData: '',
      defaultExpandIds: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      saveLoading: false,
      organDialogTitle: '',
      organDialog: false,
      organForm: [],
      organRules: {},
    }
  },
  computed: {},
  watch: {
    value(val) {
      if (val) {
        this.getUserName(val)
      } else {
        this.userName = ''
      }
    },
  },
  methods: {
    clearName() {
      this.userName = ''
      this.$emit('change', '')
    },
    // 获取用户名
    async getUserName(id) {
      if (!id) return
      const [err, res] = await eafOrganizationUnitUserApi.getUserDetail({ id })
      if (!err) {
        this.userName = res.name
        this.userId !== id && this.$emit('sentData', res)
      }
    },
    // 初始化弹窗
    initDialog() {
      this.searchPeople = ''
      this.organDialog = true
      this.getUserList()
    },
    handleSelect(row) {
      this.userName = row.name
      this.userId = row.id
      this.$emit('change', row.id)
      this.$emit('sentData', row)
      this.$emit('selected', row)
      this.organDialog = false
    },
    clearSearchName() {
      this.getUserList()
    },
    // 人员搜索
    searchPeopleFunc() {
      this.getUserList()
    },
    peopleSelectionChange(value) {
      this.multiplePeopleSelect = value
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        organizationUnitId: undefined,
        includeOrgChild: true, // 是否查询该部门子部门人员
        userName: this.searchPeople,
        sorting: '',
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.tableLoading = false
      }
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getUserList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getUserList()
    },
  },
  created() {
    if (this.value) {
      this.getUserName(this.value)
    }
    this.getUserList()
  },
}
</script>

<style scoped lang="scss">
.tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
::v-deep .el-select-dropdown__item {
  background-color: #ffffff !important;
  overflow: hidden;
  flex-wrap: nowrap;
}
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-input__validateIcon {
  display: none;
}
.vertial-border {
  background-color: #0086f7;
}
</style>
